<div class="sidebar-container">
  <div class="sidebar-header-text" *ngIf="event | async as event">
    {{ getDateRange(event.startDate, event.endDate) }}
  </div>

  <div class="sidebar-socials">
    <a href="https://www.instagram.com/wirefestival/" target="_blank">
      <img
        class="sidebar-socials-instagram"
        src="assets/imgs/instagram.svg"
        alt="instagram"
      />
    </a>
    <!-- <a [routerLink]="['tickets']" routerLinkActive="active">
      <img class="sidebar-socials-ra" src="assets/imgs/ra.svg" alt="ra" />
    </a> -->
  </div>
</div>
